import api from "./api";
import types from "./types";

import { request } from "api/apiSaga";
import { call, takeLatest } from "redux-saga/effects";
import { AnyAction } from "redux";

function* organisationsSearch(action: AnyAction) {
    yield call(request, api.organisationsSearch, action);
}

export default function* saga() {
    yield takeLatest(types.ORGANISATIONS_SEARCH_REQUEST, organisationsSearch);
}
